// Toaster: renderiza a fila de toasts (erros com errorCode traduzido + correlationId) sobre @giyus/ui Toast.
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@giyus/ui';
import { useTranslation } from 'react-i18next';

import { useToastStore } from '../lib/toast/toastStore';
import { describeToast } from './describeToast';

export function Toaster() {
  const { t } = useTranslation(['common', 'errors']);
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  return (
    <ToastProvider>
      {toasts.map((toast) => {
        const { title, description } = describeToast(toast, t);
        return (
          <Toast
            key={toast.id}
            variant={toast.kind === 'error' ? 'destructive' : 'default'}
            onOpenChange={(open) => {
              if (!open) {
                dismiss(toast.id);
              }
            }}
            data-testid="toast"
          >
            <div className="grid gap-1">
              <ToastTitle>{title}</ToastTitle>
              <ToastDescription>
                <span>{description}</span>
                {toast.correlationId && (
                  <span className="block font-mono text-caption" data-testid="toast-correlation-id">
                    {t('common:state.correlationId', { id: toast.correlationId })}
                  </span>
                )}
              </ToastDescription>
            </div>
            <ToastClose closeLabel={t('common:actions.dismiss')} />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
